import * as React from 'react'

import { cn } from '@/lib/utils'

export type TextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement>

// Mirrors the Input styling (border, bg, radius, placeholder) so it sits next to
// Inputs in a form without looking foreign. Vertical resize only.
const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, ref) => (
    <textarea
      ref={ref}
      className={cn(
        'flex min-h-[120px] w-full resize-y rounded-lg border border-neutralColor5 bg-baseColorHighlight px-3 py-2 text-sm shadow-sm transition-colors placeholder:text-neutralColor60 focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50',
        className,
      )}
      {...props}
    />
  ),
)
Textarea.displayName = 'Textarea'

export { Textarea }
